<template>
  <div>
    <base-header class="bg-vg-gradient pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col-xl-12">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">{{ variables.get('followerUsers') }}</h3>
                  <small>({{ total }} {{ variables.get('follower') }})</small>
                </div>
              </div>
            </div>
              <div class="table-responsive" v-loading="loading">
                <base-table thead-classes="thead-light"
                            :data="tableData"
                >
                  <template slot="columns">
                    <th>{{ variables.get('nameSurname') }}</th>
                    <th>{{ variables.get('applicationDate') }}</th>
                    <th>{{ variables.get('accountStatus') }}</th>
                  </template>
                  <template slot-scope="{row}">
                    <th scope="row">
                      <div class="media align-items-center">
                        <a href="#" class="avatar rounded-circle mr-3">
                          <img alt="Image placeholder" :src="'https://vizyonergenc.com/storage/'+row.user.avatar"/>
                        </a>
                        <div class="media-body">
                          <span class="name mb-0 text-sm">{{ row.user.name }}</span>
                        </div>
                      </div>
                    </th>
                    <td class="first_follow_date">{{ row.created_at | fixDate }}</td>
                    <td>
                      <badge v-if="row.user.status===1" class="badge-dot mr-4" type="success">
                        <i class="bg-success"></i>
                        <span class="status">Aktif Hesap</span>
                      </badge>
                      <badge v-else class="badge-dot mr-4" type="danger">
                        <i class="bg-danger"></i>
                        <span class="status">Pasif Hesap</span>
                      </badge>
                    </td>
                  </template>
                </base-table>
              </div>
              <div class="card-footer py-4 d-flex justify-content-between align-items-center">
                <small class="mb-0">Toplam: {{ total }}</small>
                <base-pagination v-model="currentPage" :total="total"></base-pagination>
              </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {variables} from "../langs/tr";
import * as axios from "axios";

export default {
  name: 'Followers',
  data() {
    return {
      vm: null,
      loading: true,
      variables,
      tableData: null,
      offset: 20,
      limit: 10,
      pageSizes: [5, 10, 15, 30, 50],
      total: 0,
      followers: null,
      filterForm: {},
      currentPageSize: 10,
      currentPage: 1,

      alphabeticalSortingValue: "",
      options: [{
        value: 'asc',
        label: 'A dan Z ye'
      }, {
        value: 'desc',
        label: 'Z den A ya'
      }]
    };
  },
  async created() {
    await this.getFollowers();
  },
  watch: {
    currentPage: {
      handler: "paginate",
      immediate: true
    }
  },
  methods: {
    async getFollowers() {
      this.loading = true;
      const constPost = {
        offset: this.offset,
        limit: this.limit
      };
      return await axios.post('company/follower-list', constPost).then(response => {
        if (response.status === 200) {
          this.followers = response.data.results;
          this.total = response.data.new_request_requirements.total;
          this.loading = false;
          this.tableData = response.data.results;
          return response.data;

        } else {
          alert(response.data.errno + " numaralı hata oluştu");
        }
      }).catch(e => {
        console.log(e);
      });
    },
    async prepareListData() {
      this.loading = true;
      let response = await this.getFollowers();
      this.total = response.new_request_requirements.total;
      this.loading = false;
    },
    handleSizeChange(val) {
      this.currentPageSize = val;
      this.currentPage = 1;

      this.paginate();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.paginate();
    },
    async paginate() {
      this.offset = (this.currentPage - 1) * this.currentPageSize;
      this.limit = this.currentPageSize;
      this.loading = true;
      await this.prepareListData();
      this.loading = false;
    },
    clearPagination() {
      this.currentPage = 1;
      this.offset = (this.currentPage - 1) * this.currentPageSize;
    },
  },
  filters: {
    fixDate: function (date) {
      if (!date) {
        return '';
      }
      let items = date.split(' ')[0].split('-');
      return items[2] + '.' + items[1] + '.' + items[0];
    }
  }
};
</script>

<style>
.pagi {
  color: green !important;

}
</style>
